import {Button, Dialog, DialogTrigger, Modal, ModalOverlay} from 'react-aria-components'

import AeroplaneSvg from '@/assets/flight/icons/aeroplane.svg?react'
import CloseSvg from '@/assets/icons/close.svg?react'
import LogoutSvg from '@/assets/icons/logout.svg?react'
import AddressSvg from '@/assets/icons/manage-address.svg?react'
import MenuSvg from '@/assets/icons/menu.svg?react'
import OrderSvg from '@/assets/icons/order.svg?react'
import RewardsSvg from '@/assets/icons/rewards.svg?react'
import UserSvg from '@/assets/icons/user.svg?react'
import LogoSvg from '@/assets/images/logo.svg?react'
import LogoutDialog from '@/auth/components/LogoutDialog'
import {useIsAuthenticatedValue} from '@/auth/hooks/useIsAuthenticated'
// import CountrySelector from '@/lib/locale/components/CountrySelector'
import ThemeSwitcher from '@/components/ThemeSwitcher/ThemeSwitcher'
import {
  AddressesRoute,
  FlightsRoute,
  IndexRoute,
  // HomeRoute,
  OrdersRoute,
  ProfileRoute,
  RewardsRoute,
  SignInRoute,
} from '@/routeRegistry'
import useClientValue from '@/utils/hooks/useClientValue'

import BookmarkLink from './BookmarkLink'
import style from './Sidebar.module.scss'

interface Props {
  variant?: 'light' | 'dark'
}

const LogoutButton = memo(function LogoutButton() {
  return (
    <Button className={clsx(style.RightMenuItem, style.Logout)}>
      <LogoutSvg aria-hidden />
      Logout
    </Button>
  )
})

// eslint-disable-next-line @eslint-react/prefer-read-only-props -- Ingore
export default memo(function Sidebar({variant}: Props) {
  const [isMenuShow, setIsMenuShow] = useState(false)
  const isAuthenticated = useIsAuthenticatedValue()

  const redirect = useClientValue(() => location.pathname + location.search + location.hash)

  const onClose = useCallback(() => {
    setIsMenuShow(false)
  }, [])

  const onLogout = useCallback(() => {
    setIsMenuShow(false)
  }, [])

  return (
    <DialogTrigger>
      <Button
        className={clsx(style.Button, variant === 'dark' && style.Dark)}
        onPress={() => {
          setIsMenuShow(true)
        }}
        aria-label='User menu'
        aria-checked={isMenuShow}
      >
        <MenuSvg aria-hidden />
      </Button>
      <ModalOverlay
        isOpen={isMenuShow}
        className={style.Overlay}
        isDismissable
        onOpenChange={onClose}
      >
        <Modal>
          <Dialog>
            <div
              className={clsx(style.RightMenuBar, isMenuShow && style.IsShow)}
              aria-hidden={!isMenuShow}
            >
              <div className={style.Container}>
                <div className={style.Top}>
                  <Link to={IndexRoute.fullPath}>
                    <LogoSvg className={style.LogoSvg} aria-label='Home' />
                  </Link>
                  <button type='button' onClick={onClose}>
                    <CloseSvg className={clsx(style.Icon, style.CloseSvg)} aria-label='Close' />
                  </button>
                </div>
                {isAuthenticated ? (
                  <>
                    <Link to={ProfileRoute.fullPath} className={style.RightMenuItem}>
                      <UserSvg className={style.Icon} aria-hidden />
                      Profile
                    </Link>
                    <Link to={OrdersRoute.fullPath} className={style.RightMenuItem}>
                      <OrderSvg className={clsx(style.Icon, style.Stroke)} aria-hidden />
                      Orders
                    </Link>
                    <Link to={FlightsRoute.fullPath} className={style.RightMenuItem}>
                      <AeroplaneSvg className={clsx(style.Icon, style.Stroke)} aria-hidden />
                      Flights
                    </Link>
                    <Link to={RewardsRoute.fullPath} className={style.RightMenuItem}>
                      <RewardsSvg className={clsx(style.Icon, style.Stroke)} aria-hidden />
                      Rewards
                    </Link>
                    <Link to={AddressesRoute.fullPath} className={style.RightMenuItem}>
                      <AddressSvg className={clsx(style.Icon, style.Stroke)} aria-hidden />
                      Addresses
                    </Link>
                  </>
                ) : (
                  <Link
                    to={SignInRoute.fullPath}
                    search={{
                      redirect,
                    }}
                    className={style.RightMenuItem}
                  >
                    <UserSvg className={clsx(style.Icon, style.Stroke)} aria-hidden />
                    Sign in
                  </Link>
                )}
                <BookmarkLink className={style.RightMenuItem} svgClassName={style.Icon} />
                {/* <div className={style.RightMenuItem}>
                  <img src={history} alt='' />
                  History
                </div> */}
                {/* <div className={style.RightMenuItem}>
                  <span aria-hidden>Country</span>
                  <CountrySelector />
                </div> */}
                <div className={style.RightMenuItem}>
                  <span aria-hidden>Appearance</span>
                  <ThemeSwitcher />
                </div>
                <div className={style.Bottom}>
                  {isAuthenticated && (
                    <LogoutDialog onLogout={onLogout}>
                      <LogoutButton />
                    </LogoutDialog>
                  )}
                </div>
              </div>
            </div>
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  )
})
